import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { VoiceoverQueue } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/voiceover-queue")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <VoiceoverQueue />
    </RouteGuard>
  ),
});
